import { DocumentRejectionReasonEnum } from '../../document/enums/document-rejection-reason.enum';
import { getCompanyNameForSms } from '../../../functions/get-company-name-for-sms';
import { labelsCandidateDocumentForTable } from 'common/document/ui/documents';

type ConfirmRejectionSmsProps = {
  driverName: string;
  managerName: string;
  companyName: string;
  rejectionReason: DocumentRejectionReasonEnum;
  rejectionDetails: string;
  link: string;
  documentType: string;
};

export const confirmRejectionSmsCDL = ({
  driverName,
  companyName,
  rejectionReason,
  rejectionDetails,
  link,
}: ConfirmRejectionSmsProps): string => {
  const prefix = `Hi ${driverName}, it’s ${getCompanyNameForSms({
    name: companyName,
    logo: '',
    styles: {
      mainColor: '',
      contrastTextColor: '',
    },
  })}.`;
  const suffix = `Can you please reupload it at your earliest convenience. ${link}`;
  let reasonText = `The image you uploaded of your License was rejected for the following reason: ${rejectionDetails}.`;
  switch (rejectionReason) {
    case DocumentRejectionReasonEnum.BLURRY:
      reasonText = 'The image you uploaded of your License was too blurry.';
      break;
    case DocumentRejectionReasonEnum.INCORRECT_DOCUMENT:
      reasonText = 'The image you uploaded was not a License.';
      break;
    case DocumentRejectionReasonEnum.EXPIRED:
      reasonText =
        'The image you uploaded of your License showed an expired license.';
      break;
  }
  return `${prefix} ${reasonText} ${suffix}`;
};

export const confirmRejectionSmsDOTMed = ({
  driverName,
  companyName,
  rejectionReason,
  rejectionDetails,
  link,
}: ConfirmRejectionSmsProps): string => {
  const prefix = `Hi ${driverName}, it’s ${getCompanyNameForSms({
    name: companyName,
    logo: '',
    styles: {
      mainColor: '',
      contrastTextColor: '',
    },
  })}.`;
  const suffix = `Can you please reupload it at your earliest convenience. ${link}`;
  let reasonText = `The image you uploaded of your DOT Med cert was rejected for the following reason: ${rejectionDetails}`;
  switch (rejectionReason) {
    case DocumentRejectionReasonEnum.BLURRY:
      reasonText =
        'The image you uploaded of your DOT Med cert was too blurry.';
      break;
    case DocumentRejectionReasonEnum.INCORRECT_DOCUMENT:
      reasonText = 'The image you uploaded was not a DOT Med cert.';
      break;
    case DocumentRejectionReasonEnum.EXPIRED:
      reasonText =
        'The image you uploaded of your DOT Med cert showed an expired certificate.';
      break;
  }
  return `${prefix} ${reasonText} ${suffix}`;
};

export const confirmRejectionSmsDriverChecklist = ({
  driverName,
  companyName,
  rejectionDetails,
  link,
}: ConfirmRejectionSmsProps): string => {
  const prefix = `Hi ${driverName}, it’s ${getCompanyNameForSms({
    name: companyName,
    logo: '',
    styles: {
      mainColor: '',
      contrastTextColor: '',
    },
  })}.`;
  const suffix = `Can you please reupload it at your earliest convenience. ${link}`;
  const reasonText = `The checklist you uploaded was rejected for the following reason: ${rejectionDetails}.`;
  return `${prefix} ${reasonText} ${suffix}`;
};

export const confirmGenericRejectionSms = ({
  driverName,
  companyName,
  rejectionDetails,
  link,
  documentType,
}: ConfirmRejectionSmsProps): string => {
  const prefix = `Hi ${driverName}, it’s ${getCompanyNameForSms({
    name: companyName,
    logo: '',
    styles: {
      mainColor: '',
      contrastTextColor: '',
    },
  })}.`;
  const documentName = labelsCandidateDocumentForTable.get(documentType);
  const reasonText = `The ${documentName} document you uploaded was rejected for the following reason: ${rejectionDetails}.`;
  const suffix = `Can you please reupload it at your earliest convenience. ${link}`;
  return `${prefix} ${reasonText} ${suffix}`;
};
